import {
  App,
  Button,
  Card,
  Col,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Select
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { GET_DOWNLOAD_REPORT, LIST_DOWNLOAD_COURSE_REPORT } from "../../../apis/apis";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { formatToIST } from "../../../../../src/helper/CommonHelper";

function CourseDownload() {
  const { notification } = App.useApp();

  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);

  const [total_pages, set_total_pages] = useState(0);
  const [page_size, set_page_size] = useState(10);
  const debounceRef = useRef(null);

  const [search_title, set_search_title] = useState(
    localStorage.getItem("course_download_search") || ""
  );

  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("course_download_page")) || 1
  );

  const LIST_API = async (page = current_page, title = search_title, pageSize = page_size) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", pageSize);

    if (title) FORM_DATA.append("title", title);

    const API_CALL = await LIST_DOWNLOAD_COURSE_REPORT(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
    }
    setLoader(false);
    set_pagination_loader(false);
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("course_download_page")) || 1,
      localStorage.getItem("course_download_search") || "",
      page_size
    );
  }, []);



  const DOWNLOAD_ACTION = async (id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", id);

      const API_CALL = await GET_DOWNLOAD_REPORT(FORM_DATA);

      if (API_CALL?.data?.status) {
        window.location = API_CALL?.data?.url
        notification.success({
          message: "Download Started",
          description: "file downloaded",
        });
      } else {
        notification.error({
          message: "Failed",
          description: API_CALL?.data?.error || "Download failed",
        });
      }
    } catch (err) {
      notification.error({
        message: "Server Error",
        description: "Unable to download report",
      });
    }
  };


  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_title) {
      localStorage.setItem(
        "course_download_last_search_page",
        current_page
      );
    }

    set_search_title(value);

    localStorage.setItem(
      "course_download_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "course_download_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      set_pagination_loader(true);

      LIST_API(
        pageToLoad,
        value,
        page_size
      );

    }, 500);
  };

  const pagination_on_change = async (page, size) => {

    localStorage.setItem(
      "course_download_page",
      page
    );

    set_pagination_loader(true);
    set_page_size(size);

    LIST_API(
      page,
      search_title,
      size
    );
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "report_view",
      render: (text, record) => {
        try {
          const rv = record.report_view;


          const titleMatch = rv.match(/'title':\s*'([^']+)'/);


          const nameMatch = rv.match(/'name':\s*'([^']+)'/);


          return <span>{titleMatch?.[1] || nameMatch?.[1] || "N/A"}</span>;
        } catch {
          return <span>N/A</span>;
        }
      },
    },

    // {
    //   title: "Report Type",
    //   dataIndex: "report_type",
    //   render: (text) => {
    //     const mapping = {
    //       course_learners: "Course",
    //       package_learners: "Package",
    //     };

    //     return <span>{mapping[text] || "N/A"}</span>;
    //   },
    // },

    {
      title: "Download On",
      dataIndex: "created_at",
      render: (text, record) => (
        <span>{formatToIST(record?.created_at)}</span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          onClick={() => DOWNLOAD_ACTION(record.id)}
          variant="solid"
          size="small"
          style={{ color: "white", backgroundColor: "#1fa7a1" }}
        >
          Download
        </Button>


      ),
    },
  ];

  return (
    <div >

      <Row gutter={[16, 16]} align="middle">
        <Col span={24} >
          <Input
            addonBefore={<span>Title</span>}
            placeholder="Search by title"
            size="large"
            value={search_title}
            onChange={handleInput}
          />
        </Col>
      </Row>

      {loader ? (
        <CulsightPageLoader />
      ) : (
        <>
          {pagination_loader ? (
            <div style={{ textAlign: "center", padding: "60px" }}>
              <Spin indicator={<LoadingOutlined spin />} size="large" />
            </div>
          ) : (
            <Table
              columns={columns}
              pagination={false}
              dataSource={table_data}
              style={{ marginTop: "15px" }}
              rowKey="id"
            />
          )}

          {total_pages > 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "15px",
                marginTop: "20px",
              }}
            >

              <Pagination
                current={current_page}
                onChange={pagination_on_change}
                total={total_pages * page_size}
                pageSize={page_size}
                showSizeChanger={false}
              />


              <Select
                value={page_size}
                onChange={(value) => {

                  localStorage.setItem(
                    "course_download_page",
                    1
                  );

                  set_page_size(value);

                  pagination_on_change(1, value);
                }}
                style={{ width: 120 }}
                options={[
                  { value: 10, label: "10 / page" },
                  { value: 20, label: "20 / page" },
                  { value: 50, label: "50 / page" },
                  { value: 100, label: "100 / page" },
                ]}
              />
            </div>
          ) : (
            <div style={{ textAlign: "center", color: "red" }}>
              <h2>No Data Found</h2>
            </div>
          )}

        </>
      )}

    </div>
  );
}

export default CourseDownload;
